import React from 'react';
import PropTypes from 'prop-types';

const ErrorIcon = ({ width, height }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 80 80">
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M0 0H80V80H0z"
                transform="translate(-148 -200) translate(15 136) translate(32 64) translate(101)"
              />
              <g transform="translate(-148 -200) translate(15 136) translate(32 64) translate(101) translate(10 10)">
                <circle cx="39" cy="21" r="21" fill="#E8E8E8" />
                <circle
                  cx="29"
                  cy="31"
                  r="28"
                  fill="#3F3F3F"
                  fillOpacity="0"
                  stroke="#000"
                  strokeWidth="2"
                />
                <g stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                  <path
                    d="M19.899.101L.101 19.899M19.899 19.899L.101.101"
                    transform="translate(19 21)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

ErrorIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

ErrorIcon.defaultProps = {
  width: 80,
  height: 80,
};

export default React.memo(ErrorIcon);
